import { useEffect, useState } from "react";
import { Search, Link2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Input } from "./ui/input";
import { api } from "../lib/api";
import { fmtDate, fmtNum } from "../lib/format";
import { StatusBadge } from "./Badges";

export const TxLine = ({ t }) => (
  <div className="flex min-w-0 flex-1 items-center gap-3">
    <span className="font-num w-24 shrink-0 text-sm text-slate-600">{fmtDate(t.value_date)}</span>
    <span className="min-w-0 flex-1 truncate text-sm font-medium text-slate-900">{t.merchant}</span>
    <span className={`font-num shrink-0 text-sm font-semibold ${t.amount > 0 ? "text-emerald-700" : "text-slate-900"}`}>{t.amount > 0 ? "+" : ""}{fmtNum(t.amount)} €</span>
  </div>
);

export const TransactionPicker = ({ open, onOpenChange, onPick, initialAmount }) => {
  const [q, setQ] = useState("");
  const [amount, setAmount] = useState("");
  const [list, setList] = useState([]);
  useEffect(() => { if (open) { setQ(""); setAmount(initialAmount ? fmtNum(initialAmount) : ""); } }, [open, initialAmount]);
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => api.searchTransactions(q, amount || undefined).then(setList), 250);
    return () => clearTimeout(t);
  }, [q, amount, open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl" data-testid="transaction-picker-dialog">
        <DialogHeader>
          <DialogTitle>Buchung zuordnen</DialogTitle>
          <DialogDescription>Nach Händler/Text oder Betrag suchen und Buchung anklicken.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-[1fr_140px] gap-2">
          <div className="relative">
            <Search className="absolute left-2.5 top-3 h-4 w-4 text-slate-400" />
            <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="z. B. Dropbox" className="h-10 pl-8" data-testid="picker-search-input" />
          </div>
          <Input value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Betrag" className="font-num h-10" data-testid="picker-amount-input" />
        </div>
        <div className="thin-scroll max-h-[50vh] overflow-y-auto rounded-lg border border-slate-200">
          {list.length === 0 && <div className="p-4 text-sm text-slate-500">Keine passenden Buchungen.</div>}
          {list.map((t) => (
            <button key={t.id} onClick={() => onPick(t)} data-testid={`picker-tx-${t.id}`}
              className="flex w-full items-center gap-3 border-b border-slate-100 px-3 py-2.5 text-left last:border-0 hover:bg-amber-50">
              <TxLine t={t} />
              <StatusBadge status={t.status} />
              <Link2 className="h-4 w-4 shrink-0 text-slate-400" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
